var map = {
	"./bg-jjkk.png": "Kuvf",
	"./bg-kkz.png": "hFY6",
	"./bg-yjs.png": "48NY",
	"./c-ico01.png": "W/OW",
	"./c-ico02.png": "Wshb",
	"./c-ico03.png": "i4fs",
	"./c-ico04.png": "04o+",
	"./c-label1.png": "Tci/",
	"./c-label2.png": "GNXL",
	"./c-label3.png": "9jGv",
	"./c-label4.png": "Zm60",
	"./ico-comment.png": "aW50",
	"./ico-down.png": "WIzZ",
	"./ico-homeword.png": "3Znq",
	"./ico-status1.png": "RGh2",
	"./ico-status2.png": "j96S",
	"./ico-status3.png": "ZwZx",
	"./ico-text.png": "SfdC",
	"./ico-tit.png": "wK4j",
	"./ico-up.png": "WdrD",
	"./ico-video.png": "oSs9",
	"./ico-yh.png": "AKop",
	"./ico1.png": "o5S+",
	"./ico2.png": "uTi2",
	"./ico3.png": "O3W0",
	"./ico4.png": "Cemr",
	"./ico5.png": "SwIX",
	"./intor-tit.png": "28tJ",
	"./label-bg1.png": "+jRm",
	"./star.gif": "W0z2",
	"./type-blue.png": "SWxG",
	"./type-orange.png": "GL1g"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CDW8";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/course ^\.\/.*$
// module id = CDW8
// module chunks = 1